export default "__VITE_ASSET__M1JejI9Y__"